function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7876 1.03659L14.4374 0.686406L14.7876 1.03659C14.8364 0.987803 14.9155 0.987802 14.9643 1.03659C15.0131 1.08538 15.0131 1.16449 14.9643 1.21328L1.21426 14.9633C1.16547 15.0121 1.08636 15.0121 1.03757 14.9633C0.988779 14.9145 0.988779 14.8354 1.03757 14.7866L14.7876 1.03659Z",
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.03757 1.03659C1.08636 0.987803 1.16547 0.987802 1.21426 1.03659L14.9643 14.7866C15.0131 14.8354 15.0131 14.9145 14.9643 14.9633C14.9155 15.0121 14.8364 15.0121 14.7876 14.9633L1.03757 1.21328C0.988779 1.16449 0.988779 1.08538 1.03757 1.03659L0.690218 0.689242L1.03757 1.03659Z",
  fill: "currentColor",
  stroke: "currentColor"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.2312a5cd.svg";
export { ForwardRef as ReactComponent };